import type { TimelineEvent } from "@/types/content";

export const timelineEvents: TimelineEvent[] = [
  {
    id: "tl-01",
    date: "5 月 11 日",
    time: "20:14",
    title: "首条内容出现",
    summary: "某社交平台出现一条带有截图的短帖，声称与「511 事件」相关，未附任何可核验信息。",
    detail:
      "该帖为已知时间线上最早可定位的公开内容。帖子本身没有标注素材来源，配图为一张局部截图，边缘被裁切。我们把它登记为时间线的起点，但不代表它是最早的信息源头——只代表目前能被回查到的最早公开节点。",
    status: "verified",
    sources: ["平台公开帖子存档", "网页快照（发布时间可查）"],
  },
  {
    id: "tl-02",
    date: "5 月 11 日",
    time: "22:40",
    title: "内容开始跨群扩散",
    summary: "同一张截图被转发到多个聊天群组，转发时新增了不同版本的文字说明。",
    detail:
      "扩散过程中，文字说明出现了三种不同表述，其中两种补充了截图上并没有出现的信息。这说明后续流传的部分细节，是在转发环节被加进去的，而非来自原始材料。",
    status: "verified",
    sources: ["群聊转发记录（读者提供）", "三个独立账号的转发时间线"],
  },
  {
    id: "tl-03",
    date: "5 月 12 日",
    time: "09:05",
    title: "出现首条细节补充",
    summary: "有账号发布长文，称掌握了「更多细节」，给出了具体时间与地点描述。",
    detail:
      "这篇长文给出了相对具体的时间点和地点描述，是后续讨论中被引用最多的内容之一。但我们未能定位到它以之为据的原始材料，因此其中的具体细节暂列为待证实。",
    status: "pending",
    sources: ["长文原文存档"],
  },
  {
    id: "tl-04",
    date: "5 月 12 日",
    time: "14:30",
    title: "时间戳被指出对不上",
    summary: "有用户比对截图界面元素，指出截图显示的时间与帖子发布时间存在矛盾。",
    detail:
      "质疑者给出了界面元素的版本差异对比，指出截图中出现的界面样式，其上线时间晚于帖子声称的拍摄时间。这一发现让原始截图的可信度出现第一处明显裂痕。",
    status: "conflict",
    sources: ["界面版本对比说明", "帖子发布时间戳"],
  },
  {
    id: "tl-05",
    date: "5 月 12 日",
    time: "19:52",
    title: "原始出处初步定位",
    summary: "通过反向检索，找到截图与更早一张公开图片高度相似，疑似同源。",
    detail:
      "我们使用反向图搜与元数据比对，定位到一张发布时间更早的公开图片。两者在构图与光影上高度接近，但清晰度与裁切范围不同。是否为同一素材，仍需要更高质量的原图才能确认。",
    status: "pending",
    sources: ["反向图搜结果", "较早公开图片存档"],
  },
  {
    id: "tl-06",
    date: "5 月 13 日",
    time: "11:20",
    title: "两处说法互相对立",
    summary: "关于事件发生的地点，先后出现两种彼此不兼容的描述，双方各执一词。",
    detail:
      "一组来源描述的地点与另一组来源相差较远，且两方都声称自己掌握现场信息。截至目前没有任何一方给出可独立验证的材料，因此该条目保留为存在矛盾。",
    status: "conflict",
    sources: ["来源组 A 表述", "来源组 B 表述"],
  },
  {
    id: "tl-07",
    date: "5 月 13 日",
    time: "16:45",
    title: "一条传闻被排除",
    summary: "流传较广的一则「关联人物」说法，被证实为同名误认。",
    detail:
      "该说法把两个同名个体混为一谈。我们核对了两人可公开查询的活动轨迹，时间与地点均不重合，可以确认是误认。相关条目已从传播榜单中撤下并注明原因。",
    status: "verified",
    sources: ["公开活动记录比对", "姓名与时间线交叉核对"],
  },
  {
    id: "tl-08",
    date: "5 月 14 日",
    time: "10:08",
    title: "关键材料补全",
    summary: "读者提供了一份分辨率更高的原始文件，此前多处疑点得以逐步厘清。",
    detail:
      "新提供的文件保留了完整的元信息，可以确认拍摄时间区间。它同时印证了时间线前段的两个节点，也推翻了第 4 条中存在争议的时间戳说法。这是本次梳理中影响最大的一份补充材料。",
    status: "verified",
    sources: ["读者提供的原始文件", "文件元信息", "与既有节点交叉验证"],
  },
  {
    id: "tl-09",
    date: "5 月 15 日",
    time: "18:00",
    title: "证据对照表更新",
    summary: "全部条目完成一轮对照，状态分布基本确定，档案进入维护期。",
    detail:
      "本轮共完成 128 条线索的登记与对照，其中 73 条达到已核实标准，19 处仍存在矛盾，36 条维持待证实。后续如有新材料，我们会在时间线与对照表中同步更新。",
    status: "verified",
    sources: ["证据对照表 v1.3", "时间线修订记录"],
  },
];